import { CartSelectedService } from "~/types/cart";
import { ICartPersonalInfo, IStoreCartState } from "~/types/store/cart";

export function cartPersonalInfo(state) {

    let val = null;

    try {
        val = JSON.parse(localStorage.getItem('cartPersonalInfo'));
    } catch {
        val = state.cartPersonalInfo;
    }

    return val;
}

export function selectedItems(state: IStoreCartState) {
    return state.cart.filter((el) => el.selected);
}

export function itemsPrice(state: IStoreCartState) {
    return state.cart.filter((el) => el.selected).reduce((carry, el) => (el.price * el.quantity) + carry, 0);
}

export function itemsDiscount(state: IStoreCartState) {
    return state.cart.filter((el) => el.selected && el.discount).reduce((carry, el) => (el.discount * el.quantity) + carry, 0);
}

export function expressDeliveryStatus(state: IStoreCartState) {
    const remainsMap = new Map<number, number>();

    state.offers.forEach((value) => {
        remainsMap.set(value.id, value.express);
    });

    state.cart.filter((el) => el.selected).forEach((item) => {
        remainsMap.set(item.offer, (remainsMap.get(item.offer) || 0) - item.quantity);
    });

    const remains = Array.from(remainsMap.values());

    return [remains.findIndex((el) => el >= 0) !== -1, remains.findIndex((el) => el < 0) !== -1];
}

export function selectedServices(state: IStoreCartState): CartSelectedService[] {

    if (typeof sessionStorage !== 'undefined' && !state.selectedServices) {
        const item = sessionStorage.getItem('cart-selected-services-v2');

        if (item) {

            const services = JSON.parse(item) as CartSelectedService[];

            if (services) {
                return services;
            }
        }
    }

    return state.selectedServices || [];
}

export function personalInfo(state: IStoreCartState): ICartPersonalInfo {

    if (typeof sessionStorage !== 'undefined' && !state.personalInfo) {
        const item = sessionStorage.getItem('cart-personal-info');

        if (item) {
            return (JSON.parse(item) as ICartPersonalInfo);
        }
    }

    return state.personalInfo || {
        name: '',
        surname: '',
        phone: '',
        email: '',
        address: '',
    };
}

export function services(state) {

    return state.services;
}
